export const loadScript = (resource: string, callback?: (script: HTMLElement) => void): void => {
  const script = document.createElement("script");

  script.type = "text/javascript";
  script.src = resource + "?t=" + new Date().getTime(); //prevent caching

  if (callback) {
    script.onload = (): void => {
      callback(script);
    };
    script.onerror = (): void => {
      throw new Error("failed to load script file " + resource);
    };
  }

  document.body.appendChild(script);
};
